var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Menu } from '@pocketlaw/tetris';
import { useSearchableMenu } from './SearchableMenuContext';
export function SearchableMenuPopover(props) {
    const { renderTarget, children, useTargetWidth } = props, menuProps = __rest(props, ["renderTarget", "children", "useTargetWidth"]);
    const { initiallyOpen, onClose } = useSearchableMenu();
    return (<Menu.Root initiallyOpen={initiallyOpen} target={renderTarget} onClose={onClose} useTriggerWidth={useTargetWidth} maxWidth="unset" {...menuProps}>
      {children}
    </Menu.Root>);
}
